import { CustomTypographyComponentProps } from "../types";
import { Typography } from "@mui/material";

export const H6Typography = ({
  children,
  ...props
}: CustomTypographyComponentProps) => {
  return (
    <Typography variant="h6" {...props}>
      {children}
    </Typography>
  );
};
